// extracted by mini-css-extract-plugin
export default {"narrowContainer":"Broadcast_narrowContainer__jU2kF","clickableItem":"Broadcast_clickableItem__+W9cx"};